import keys from '@/config/keys'
import isEmpty from '@/utils/isEmpty'
import { createSlice } from '@reduxjs/toolkit'

const { AUTH_TOKEN } = keys

const initialState = { isAuthenticated: false, user: null, isGuest: false }

/* Store auth state */
const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		setCurrentUser(state, { payload }) {
			const payloadExist = !isEmpty(payload)
			let customProps = {}
			if (payloadExist) {
				// Any custom property that you want to add to the user object can be added here.
			}
			return {
				...state,
				isAuthenticated: payloadExist,
				user: payloadExist ? { ...(payload ?? {}), ...(customProps ?? {}) } : payload,
			}
		},
		logoutUser() {
			/* Remove 'AUTH_TOKEN' from localStorage */
			localStorage.removeItem(AUTH_TOKEN)
			/* Set isAuthenticated: false & user: null */
			return { ...initialState }
		},
		setIsGuest(state, { payload }) {
			return { ...state, isGuest: payload }
		},
	},
})

export const { setCurrentUser, logoutUser, setIsGuest } = authSlice.actions

export default authSlice.reducer
